/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Roles/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaSelect from 'DesignSystem/TysiaSelect/index'
import TysiaSelectContent from 'DesignSystem/TysiaSelect/TysiaSelectContent/index'
import TysiaSelectField from 'DesignSystem/TysiaSelect/TysiaSelectField/react'



/** @type {import('Simple/types.js').View} */
export default function Roles({
  children,
  viewPath = "/DesignSystem/DataVaxiomRelationshipsItem/ViewDetails/Content/Relationship/Roles",
  isInvalid,
  onChange
  
}) {
let rolesValueData = fromData.useDataValue({ viewPath,
context: 'roles',
})
let editRelationRoleValueData = fromData.useDataValue({ viewPath,
context: 'edit_relation',
path: 'role',
})
let editRelationRoleIsValidData = fromData.useDataIsValid({ viewPath,
context: 'edit_relation',
path: 'role',
validate: fromValidate.text,
required: true,
})
let editRelationRoleChangeData = fromData.useDataChange({ viewPath,
context: 'edit_relation',
path: 'role',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaSelect
  viewPath={`${viewPath}/TysiaSelect`}
 marginLeft={dtSpaceS}
 maxWidth={180}
 data="roles"
 from={rolesValueData}
 data="edit_relation.role"
 allowEmptyChoice={false}
 validate="/Data/validate.js text"
 invalid={!editRelationRoleIsValidData}
 required={true}
 value={editRelationRoleValueData}
 onChange={editRelationRoleChangeData}
>
{childProps => (
<TysiaSelectContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectContent`}
>
{childProps => (
<TysiaSelectField
{...childProps}
  viewPath={`${viewPath}/TysiaSelectField`}
/>
)}
</TysiaSelectContent>
)}
</TysiaSelect>
{children}
</React.Fragment>)
}